function SvgPen({ className, currentColor, stroke }) {
  return (
    <svg
      className={`${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4894_29995)">
        <path
          d="M14.168 0.754702C15.1445 -0.221782 16.7305 -0.221782 17.707 0.754702L19.2461 2.29494C20.2227 3.27111 20.2227 4.85548 19.2461 5.83205L17.3555 7.72267L12.2773 2.64533L14.168 0.754702ZM16.4727 8.60548L7.36328 17.711C6.95703 18.1172 6.45312 18.418 5.90234 18.5781L1.20194 19.961C0.873038 20.0586 0.517179 19.9688 0.274601 19.6914C0.0320146 19.4844 -0.0586808 19.1289 0.0381162 18.7969L1.42069 14.0977C1.5832 13.5469 1.88124 13.043 2.28788 12.6367L11.3945 3.52892L16.4727 8.60548Z"
          fill={currentColor || "#000000"}
          stroke={stroke ? "#000000" : ""}
          strokeWidth={stroke ? "1" : ""}
        />
      </g>
      <defs>
        <clipPath id="clip0_4894_29995">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPen;
